import { createFileRoute } from '@tanstack/react-router'

import { QuestionnaireDetailPage } from '@/components/questionnaires/questionnaire-detail'
import { RETURN_SHAPE } from '@/lib/return-to'
import { readSearch } from '@/lib/search-params'

/** Un questionnaire, par son `short_id` (chemin écrit au contrat 1.56.0). */
export const Route = createFileRoute('/_app/questionnaires/$shortId')({
  // #401 : « Retour » ramène à la liste filtrée, ou à la carte du tableau de bord.
  validateSearch: (search: Record<string, unknown>) => readSearch(RETURN_SHAPE, search),
  component: QuestionnaireRoute,
})

function QuestionnaireRoute() {
  const { shortId } = Route.useParams()
  return <QuestionnaireDetailPage shortId={shortId} />
}
